export var stepperPortalTokens = {
  status: {
    done: {
      customIconColor: function customIconColor(_ref) {
        var palette = _ref.palette;
        return palette.newBlue.hex40;
      },
      borderColor: function borderColor(_ref2) {
        var palette = _ref2.palette;
        return palette.newBlue.hex40;
      },
      bgColor: "transparent",
      contentColor: function contentColor(_ref3) {
        var palette = _ref3.palette;
        return palette.newBlue.hex40;
      }
    },
    progress: {
      customIconColor: function customIconColor(_ref4) {
        var palette = _ref4.palette;
        return palette.newBlue.hex40;
      },
      borderColor: function borderColor(_ref5) {
        var palette = _ref5.palette;
        return palette.newBlue.hex40;
      },
      bgColor: function bgColor(_ref6) {
        var palette = _ref6.palette;
        return palette.newBlue.hex40;
      },
      contentColor: function contentColor(_ref7) {
        var palette = _ref7.palette;
        return palette.neutralsWhite.rgba90;
      }
    },
    wait: {
      customIconColor: function customIconColor(_ref8) {
        var color = _ref8.color;
        return color.text.secondary.disable;
      },
      borderColor: function borderColor(_ref9) {
        var color = _ref9.color;
        return color.text.secondary.disable;
      },
      bgColor: "transparent",
      contentColor: function contentColor(_ref10) {
        var color = _ref10.color;
        return color.text.secondary.disable;
      }
    },
    error: {
      customIconColor: function customIconColor(_ref11) {
        var color = _ref11.color;
        return color.importance.danger.base;
      },
      borderColor: function borderColor(_ref12) {
        var color = _ref12.color;
        return color.importance.danger.base;
      },
      bgColor: function bgColor(_ref13) {
        var color = _ref13.color;
        return color.importance.danger.base;
      },
      contentColor: function contentColor(_ref14) {
        var palette = _ref14.palette;
        return palette.neutralsWhite.rgba90;
      }
    }
  },
  connectorLineColor: {
    done: function done(_ref15) {
      var palette = _ref15.palette;
      return palette.newBlue.hex40;
    },
    base: function base(_ref16) {
      var palette = _ref16.palette;
      return palette.neutralsBlack.hex15;
    }
  },
  contentColor: {
    labelActive: function labelActive(_ref17) {
      var color = _ref17.color;
      return color.text.black.base;
    },
    descriptionActive: function descriptionActive(_ref18) {
      var color = _ref18.color;
      return color.text.secondary.base;
    },
    label: function label(_ref19) {
      var color = _ref19.color;
      return color.text.secondary.disable;
    },
    description: function description(_ref20) {
      var color = _ref20.color;
      return color.text.secondary.disable;
    }
  },
  sizes: {
    s: {
      symbolWrapper: 24,
      baseSymbol: 20,
      baseSymbolIcon: 14,
      contentMarginLeft: 6,
      lineMarginX: 6,
      lineMarginY: 8,
      label: "s",
      description: "xs"
    },
    m: {
      symbolWrapper: 30,
      baseSymbol: 26,
      baseSymbolIcon: 18,
      contentMarginLeft: 8,
      lineMarginX: 8,
      lineMarginY: 10,
      label: "m",
      description: "xs"
    }
  },
  applyStandardLineHeightToSymbol: true,
  descriptionPaddingRight: 18,
  descriptionPaddingTop: 2
};